import axios from 'axios';
import { API } from '../global/global';

export interface TagTracksolid {
  id: number;
  imei: string;
  device_name: string;
  plate?: string;
  mc_type?: string;
  longitude?: number | string;
  latitude?: number | string;
  speed?: number | string;
  device_status?: string;
  pos_type?: string;
  acc_status?: string;
  elect_quantity?: string;
  dateTime?: string;
  estatus: string;
  ultima_actualizacion?: string;
  plataforma_id?: number;
  tracksolid_account?: string;
  ultima_posicion?: {
    longitude: string;
    latitude: string;
    speed?: number;
    event?: string;
    dateTime_tracksolid?: string;
    fecha_actualizacion?: string;
  };
}

export interface TracksolidEstadisticas {
  total_tags: number;
  tags_activos: number;
  tags_online: number;
  tags_con_posicion: number;
  tags_sin_posicion: number;
}

export interface TrazabilidadTracksolidPunto {
  id: number;
  longitude: number | string;
  latitude: number | string;
  speed?: number | string;
  event?: string;
  dateTime_tracksolid?: string;
  fecha_registro: string;
  distancia_recorrida?: number | string;
  tiempo_transcurrido?: number | string;
  velocidad_promedio?: number | string;
  tipo_evento: string;
}

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };
};

export const tracksolidApi = {
  getAllTags: async (): Promise<TagTracksolid[]> => {
    const response = await axios.get(`${API}/tracksolid/tags`, {
      headers: getAuthHeaders(),
      timeout: 10000,
    });
    return response.data.data || [];
  },

  getEstadisticas: async (): Promise<TracksolidEstadisticas> => {
    const response = await axios.get(`${API}/tracksolid/estadisticas`, {
      headers: getAuthHeaders(),
      timeout: 10000,
    });
    return response.data.estadisticas;
  },

  getTrazabilidad: async (tagId: number, fechaInicio?: string, fechaFin?: string): Promise<{ tag: any; trazabilidad: TrazabilidadTracksolidPunto[]; total_puntos: number }> => {
    const params: Record<string, string> = {};
    if (fechaInicio) params.fecha_inicio = fechaInicio;
    if (fechaFin) params.fecha_fin = fechaFin;
    const response = await axios.get(`${API}/tracksolid/tags/${tagId}/trazabilidad`, {
      headers: getAuthHeaders(),
      params,
      timeout: 15000,
    });
    return response.data;
  },

  sincronizar: async (account: string = 'skyangelmonitoreo'): Promise<any> => {
    const response = await axios.post(`${API}/tracksolid/sincronizar`, { account }, {
      headers: getAuthHeaders(),
      timeout: 30000,
    });
    return response.data;
  },

  // Subcuentas
  getSubcuentas: async (): Promise<any[]> => {
    const response = await axios.get(`${API}/tracksolid/subcuentas`, {
      headers: getAuthHeaders(),
    });
    return response.data.data || [];
  },

  fetchSubcuentasApi: async (account: string = 'skyangelmonitoreo'): Promise<any> => {
    const response = await axios.post(`${API}/tracksolid/subcuentas/fetch-api`, { account }, {
      headers: getAuthHeaders(),
      timeout: 30000,
    });
    return response.data;
  },

  guardarSubcuenta: async (data: { tracksolid_account: string; subcuenta: string; plataforma_id: number; activa?: boolean }): Promise<any> => {
    const response = await axios.post(`${API}/tracksolid/subcuentas`, data, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  eliminarSubcuenta: async (id: number): Promise<any> => {
    const response = await axios.delete(`${API}/tracksolid/subcuentas/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  getDispositivosSubcuenta: async (subcuenta: string, account: string = 'skyangelmonitoreo'): Promise<any> => {
    const response = await axios.post(`${API}/tracksolid/subcuentas/dispositivos`, { subcuenta, account }, {
      headers: getAuthHeaders(),
      timeout: 30000,
    });
    return response.data;
  },
};
